var AlertLooks;
(function (AlertLooks) {
  AlertLooks["Error"] = 'error';
  AlertLooks["None"] = 'none';
  AlertLooks["Success"] = 'success';
  AlertLooks["Warning"] = 'warning';
})(AlertLooks || (AlertLooks = {}));
var AlertTypes;
(function (AlertTypes) {
  AlertTypes["Assertive"] = 'assertive';
  AlertTypes["Polite"] = 'polite';
})(AlertTypes || (AlertTypes = {}));
export { AlertLooks, AlertTypes };